if (!customElements.get('pms-deliboy')) {
  customElements.define('pms-deliboy', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.van = this.querySelector('[data-deliboy-van]');
      this.button = this.querySelector('[data-deliboy-wiggle]');
      if (!this.van) return;
      this.updateMotion = () => {
        this.van.classList.remove('is-wiggling');
        if (this.button) this.button.hidden = this.motion.matches;
      };
      this.updateMotion();
      this.motion.addEventListener('change', this.updateMotion, options);
      this.button?.addEventListener('click', () => this.wiggle(), options);
      this.querySelector('[data-deliboy-link]')?.addEventListener('pointerenter', () => this.wiggle(), options);
      this.querySelector('[data-deliboy-link]')?.addEventListener('focus', () => this.wiggle(), options);
      this.van.addEventListener('animationend', () => this.van.classList.remove('is-wiggling'), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.van.classList.remove('is-wiggling');
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.wiggle();
            this.observer.disconnect();
          }
        }, {threshold: 0.35});
        this.observer.observe(this.van);
      }
    }
    wiggle() {
      if (this.motion.matches || document.hidden || this.van.classList.contains('is-wiggling')) return;
      this.van.classList.add('is-wiggling');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = null;
    }
  });
}
